import { DocumentIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';
import { MIME_TYPES } from '@/constants';

import { ReactComponent as HeroFileWord } from '../../../assets/icons/document-doc.svg';
import { ReactComponent as HeroFileJson } from '../../../assets/icons/document-json.svg';
import { ReactComponent as HeroFilePdf } from '../../../assets/icons/document-pdf.svg';
import { ReactComponent as HeroFilePpt} from '../../../assets/icons/document-ppt.svg';
import { ReactComponent as HeroFileText } from '../../../assets/icons/document-txt.svg';
import { ReactComponent as HeroFileExcel } from '../../../assets/icons/document-xls.svg';
import { ReactComponent as HeroFileArchive } from '../../../assets/icons/document-zip.svg';

interface NonDrawableURLPreviewProps {
    mimeType?: string;
    className?: string;
    /** Hit list: light gray until the row is hovered. */
    muted?: boolean;
}

const NonDrawableURLPreview = ({ mimeType, className, muted = false }: NonDrawableURLPreviewProps) => {
    const size = 'tw-h-8 tw-w-8';
    const variant = 'dark';
    const toneClass = muted ? 'hit-list-document-icon tw-icon-inactive' : `icon-variant-${variant}`;

    switch(mimeType) {
        case MIME_TYPES.APPLICATION_PDF:
            return <HeroFilePdf className={`${toneClass} ${size}${className ? ` ${className}` : ''}`} data-testid="file-pdf"/>;

        case MIME_TYPES.APPLICATION_MS_EXCEL:
        case MIME_TYPES.APPLICATION_VND_EXCEL:
        case MIME_TYPES.APPLICATION_VND_EXCEL_SHEET:
        case MIME_TYPES.TEXT_CSV:
            return <HeroFileExcel className={`${toneClass} ${size}${className ? ` ${className}` : ''}`}/>;

        case MIME_TYPES.APPLICATION_MS_POWERPOINT:
        case MIME_TYPES.APPLICATION_VND_POWERPOINT:
            return <HeroFilePpt className={`${toneClass} ${size}${className ? ` ${className}` : ''}`}/>;

        case MIME_TYPES.APPLICATION_VND_WORD:
        case MIME_TYPES.APPLICATION_MS_WORD:
            return <HeroFileWord className={`${toneClass} ${size}${className ? ` ${className}` : ''}`}/>;

        case MIME_TYPES.APPLICATION_JSON:
            return <HeroFileJson className={`${toneClass} ${size}${className ? ` ${className}` : ''}`}/>;

        case MIME_TYPES.APPLICATION_GZIP:
        case MIME_TYPES.APPLICATION_ZIP:
        case MIME_TYPES.APPLICATION_VND_RAR:
            return <HeroFileArchive className={`${toneClass} ${size}${className ? ` ${className}` : ''}`}/>;

        case MIME_TYPES.TEXT_PLAIN:
            return <HeroFileText className={`${toneClass} ${size}${className ? ` ${className}` : ''}`}/>;

        default:
            return (
                <Icon
                    icon={DocumentIcon}
                    size='2xl'
                    variant={muted ? 'default' : variant}
                    className={muted ? `hit-list-document-icon tw-icon-inactive ${className ?? ''}` : className}
                />
            );
    }
};

export { NonDrawableURLPreview };
